module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/341.9e77f6dd.png";